import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const ITSupport = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / IT Support</h6>
          <hr />
          <h1 className="banner-title">
            Reliable IT Support to <br /> Keep Your Business Running Smoothly
          </h1>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>
        <img
          src="./assets/img/it_support2.jpg"
          alt="IT Support Banner"
          className="banner-image"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h6 className="col_yell">IT Support</h6>
              <h2>About Our IT Support Services</h2>
              <p>
                Our IT support team ensures seamless operations by providing
                fast, secure, and reliable solutions. From troubleshooting
                technical issues to maintaining IT infrastructure, we are here
                to help.
              </p>
              <ol>
                <li>24/7 Help Desk Support</li>
                <li>Network Security & Monitoring</li>
                <li>Cloud & Server Management</li>
                <li>System Maintenance & Troubleshooting</li>
              </ol>
            </div>
            <div className="col-md-6">
              <img
                src="./assets/img/it_support2.jpg"
                alt="IT Support Services"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services py-5 bg-black text-white">
        <div className="container">
          <h2 className="text-center mb-4">Our IT Support Services</h2>
          <div className="row">
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-headset fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Help Desk Support</h5>
              <p>24/7 assistance for technical issues and troubleshooting.</p>
            </div>
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-tools fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Hardware & Software Support</h5>
              <p>Expert troubleshooting for hardware and software issues.</p>
            </div>

            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-server fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Cloud Solutions</h5>
              <p>
                Scalable cloud services for secure and flexible IT operations.
              </p>
            </div>
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-network-wired fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Network Management</h5>
              <p>Ensure a stable and secure IT network infrastructure.</p>
            </div>
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-sync-alt fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>System Updates & Maintenance</h5>
              <p>Keep your systems up-to-date and running smoothly.</p>
            </div>
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-cogs fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>IT Consulting</h5>
              <p>Strategic IT planning for your business growth.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4  pt-5 pb-5 mx-0 px-4">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="">Need Reliable IT Support?</h2>
                <p className="mt-3">
                  Contact us today and let’s ensure your business stays online,
                  secure, and efficient.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="./assets/img/2007.png"
                        className="w-100"
                        alt="IT Support"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ITSupport;
